module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_vm._v("OPOR HOREV")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ILDF Front D HQ issued OPOR HOREV on 20 December 1948. Main participating forces were Brigade 1, Brigade 3, Brigade 8, Brigade 12 and elements of Brigade 10. HOREV’s objective was the defeat of EGDF in Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main effort was an advance of Brigade 8 and Brigade 12, plus elements of Brigade 10, in the direction of Auja and Abu Ageila.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The secondary effort was a Brigade 1 attack against EGDF in Gaza, Rafah and the El Arish sector.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brigade 10 was in reserve while Brigade 3 was tasked to preserve a blockade of the Faluja Pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Horev timetable was:")]), _vm._v(" "), _c('table', {
    staticClass: "table111"
  }, [_c('colgroup', [_c('col', {
    staticClass: "a50"
  }), _vm._v(" "), _c('col', {
    staticClass: "a50"
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("22 December 1948 dusk")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("ILAF attack")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("22 – 23 December 1948")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Brigade 1 attack")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("24 – 25 December 1948")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Brigade 12 attack")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("25 December 1948 dawn")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Brigade 8 attack Auja")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("ILAF was tasked to accomplish air superiority and provide air support. Preplanned operations were:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p3-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Squadron 101 was tasked to patrol and photograph. Squadron 2 and Squadron 3 – the former moved from Dorot to Beer Sheba on 21 December 1948; the latter deployed from Ramat David to Tel Nof on 20 December 1948 – were to fly observation and liaison.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a5228d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Opor.vue
// module id = 81
// module chunks = 0